import { createTheme } from '@material-ui/core/styles';
import * as R from 'ramda';

import baseTheme, { baseMuiTheme } from './base-theme';

const eventOverrides = {
  palette: {
    secondary: {
      main: '#c2d92b',
    },
  },
};

export const muiTheme = createTheme(
  R.mergeDeepRight(baseMuiTheme, eventOverrides),
);

export default R.mergeDeepRight(baseTheme, {
  name: 'Conferencing',
  header: {
    background: '#29B162',
    titleColor: '#ffffff',
  },
});
